// src/components/dlog/DlogViewer.tsx
import React from 'react';
import { DlogItem } from '../../models/Dlog';
import './Dlog.css';

interface DlogViewerProps {
  selectedLog: DlogItem | null;
  maxLines?: number; // Optional prop to limit lines shown
}

const DlogViewer: React.FC<DlogViewerProps> = ({ selectedLog, maxLines = 100 }) => {
  const getDisplayContent = () => {
    if (!selectedLog) {
      return 'Select a log from the table above to view its content.';
    }
    // Basic check for binary-like content (can be improved)
    // eslint-disable-next-line 
    if (/[\x00-\x08\x0E-\x1F]/.test(selectedLog.content.substring(0, 1000))) {
        return 'Cannot display binary content.';
    }

    const lines = selectedLog.content.split('\n');
    const displayLines = lines.slice(0, maxLines);
    let contentToShow = displayLines.join('\n');

    if (lines.length > maxLines) {
      contentToShow += `\n\n... (truncated - showing first ${maxLines} of ${lines.length} lines)`;
    }
    return contentToShow;
  };

  return (
    <>
     {selectedLog  && (<h2>Selected Log: {selectedLog.name}</h2>)}
     <div className="dlog-viewer-container">
      <textarea
        readOnly
        value={getDisplayContent()}
        className="dlog-viewer-textarea"
        placeholder="Log content will appear here..."
      />
    </div>
    </>
  );
};

export default DlogViewer;
